import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuetify from 'vuetify'
import { i18n } from './i18n'
import 'vuetify/dist/vuetify.min.css'
import store from './vuex/store'
import { common } from './mixins/common.js'
import DebugCodeBlock from '@/components/DebugCodeBlock.vue'
import '@/assets/js/filters.js'
import VueCompositionAPI from '@vue/composition-api'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(VueCompositionAPI)
Vue.use(DebugCodeBlock)
Vue.component('DebugCodeBlock', DebugCodeBlock)

Vue.mixin(common)
Vue.config.productionTip = false

Vue.use(Vuetify, {
  theme: {
    primary: '#00B9E6',
  },
})

new Vue({ router, store, i18n, render: h => h(App) }).$mount('#app')
